// extracted by mini-css-extract-plugin
module.exports = {"container":"regularmealstatus_container__1nTtV","noMargin":"regularmealstatus_noMargin__1Sn2m","table":"regularmealstatus_table__360Ti","oneRow":"regularmealstatus_oneRow__2iBvI"};